import { IRideDto } from "../../dto";

// Self-removal via the passenger app sets metadata.hasSelfRemovedPassengers without updatedUserId (RYDE-7872)
export const shouldShowUserUpdaterIndicator = (
  rideDto: Partial<IRideDto> | undefined,
): boolean => {
  return (
    !!rideDto?.updatedUserId ||
    rideDto?.metadata?.hasSelfRemovedPassengers === true
  );
};
